import * as core from '../../../../../../../core'
import * as changeImpactFunctionalArea from '../change-impact-functional-area'

export const RESOURCE = {
  payload: {
    description: 'Marketing Cloud',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactFunctionalArea.RESOURCE.payload.partialId,
    }),
    id: 'Marketing Cloud',
    name: 'Marketing Cloud',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
